import type { OfferListItem } from '@fos/shared/contracts/offers';
import { OFFER_STATUS_LABELS, OFFER_STATUS_TONES } from '@fos/shared/labels';
import { useAccess } from '../../../lib/useAccess';
import { ClientChip } from '../../../ui/EntityLabel';
import { ListRow } from '../../../ui/ListRow';
import { Mono } from '../../../ui/Mono';
import { StatusPill } from '../../../ui/StatusPill';
import { ClientDot } from '../../clients/components/ClientDot';
import { offerHoursText, offerHref, offerMoneyText, offerRowDescription } from '../offer-format';

/**
 * Wiersz oferty (lista ofert, zakładka „Oferty” w profilu klienta): tytuł, pod nim klient jako chip w jego barwie
 * (lifting 17.10.2026; w profilu klienta bez chipu — kropka klienta), „#nr · wersja”, godziny i wartość (mono;
 * wartość tylko z „Widzi stawki i kwoty”, także na telefonie), status jako pigułka. Cały wiersz prowadzi do oferty.
 */
export function OfferRow({ offer, withClient = true }: { offer: OfferListItem; withClient?: boolean }) {
  const access = useAccess();
  const hours = offerHoursText(offer);
  const money = access.flag('seesRates') && offer.totalNet ? offerMoneyText(offer.totalNet, offer.currency) : null;
  return (
    <ListRow
      to={offerHref(offer.id)}
      leading={withClient ? undefined : <ClientDot color={offer.client.color} />}
      title={offer.title}
      description={
        withClient ? (
          <span className="mt-0.5 flex min-w-0 items-center gap-1.5">
            <ClientChip client={offer.client} />
            <span className="min-w-0 truncate">{offerRowDescription(offer, false)}</span>
          </span>
        ) : (
          offerRowDescription(offer, false)
        )
      }
      trailing={
        <>
          {hours && <Mono className="hidden text-body-s text-fg-secondary sm:inline">{hours}</Mono>}
          {money && <Mono className="text-body-s font-medium text-fg max-md:text-caption">{money}</Mono>}
          <StatusPill tone={OFFER_STATUS_TONES[offer.status]}>{OFFER_STATUS_LABELS[offer.status]}</StatusPill>
        </>
      }
    />
  );
}
